import { useEffect, useCallback } from 'react';
import couponAtom from '~/recoil/atom/coupon';
import itemsTotalPerStoreMapSelector from '~/recoil/selectors/itemsTotalPerStoreMap';
import { useRecoilValue } from 'recoil';

import useCartId from '~/hooks/useCartId';

import isAfter from 'date-fns/isAfter';
import parseISO from 'date-fns/parseISO';

import * as fp from 'lodash/fp';

import updateCart from '~/firebase/update/updateCart';
import { PLATFORM_ID } from '~/globalVariables';

export default function useCouponCheck(isOrderer: boolean) {
  const coupon = useRecoilValue(couponAtom);
  const itemsTotalPerStoreMap = useRecoilValue(itemsTotalPerStoreMapSelector);

  const { cartId } = useCartId();

  const handleClearCoupon = useCallback(async () => {
    try {
      console.log('clear coupon');
      await updateCart(PLATFORM_ID, cartId, {
        campaignId: '',
        coupon: null,
      });
    } catch (err) {}
  }, [cartId]);

  useEffect(() => {
    if (!isOrderer || !coupon) {
      return;
    }

    if (isAfter(new Date(), parseISO(coupon.endDate))) {
      console.log('date expired');
      handleClearCoupon();
      return;
    }

    const costLimit = fp.isNumber(coupon.condition[coupon.type]?.costLimit)
      ? coupon.condition[coupon.type]?.costLimit || 0
      : Infinity;

    if (
      !coupon.stores.some((id) => itemsTotalPerStoreMap.has(id)) ||
      fp.lt(fp.sum(coupon.stores.map((id) => itemsTotalPerStoreMap.get(id) || 0)), costLimit)
    ) {
      console.log('clear less than');
      handleClearCoupon();
      return;
    }
  }, [isOrderer, coupon, itemsTotalPerStoreMap, handleClearCoupon]);
}
